const translations = {
    addAircraft: 'Add Aircraft',
    addController: 'Add Controller',
    address: 'Address',
    aircraft: 'Aircraft',
    certificateOfAuthorizationNumber: 'Certificate of Authorization Number',
    certifications: 'Certifications & Exemptions',
    city: 'City',
    companyDetails: 'Company Details',
    companyName: 'Company Name',
    contactName: 'Name',
    controllers: 'Controllers',
    details: 'Details',
    edit: 'Edit',
    email: 'Email',
    equipment: 'Equipment',
    equipmentSubtitle: 'Aircraft and controllers registered to your organization',
    faaDocketNumber: 'FAA Docket Number',
    faaExemptionNumber: 'FAA Exemption Number',
    invitations: 'Invitations',
    inviteUser: 'Invite User',
    notProvided: 'Not provided',
    organization: 'Organization',
    organizationSubtitle: 'Company details, person of contact and certifications',
    personOfContact: 'Person of Contact',
    phone: 'Phone',
    state: 'State',
    subscription: 'Subscription',
    users: 'Users',
    usersSubtitle: 'Team members and pending invitations for your organization',
    zip: 'Zip'
};

export default translations;
